import { render, staticRenderFns } from "./WishlistView.vue?vue&type=template&id=39a6ae20&"
import script from "./WishlistView.vue?vue&type=script&lang=js&"
export * from "./WishlistView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports